import styled from "styled-components";
import { globalStyles } from "../../util/globalStyles";
import { MyButton } from "../../components/button/styles";

export const PageContent = styled.div`
    margin-top: 2rem;
    margin-bottom: 6rem;
    display: flex;
    justify-content: space-between;

    @media only screen and (max-width: ${globalStyles.breakpoints.large}) {
        flex-direction: column;
    }
`

export const ContactFormWrapper = styled.form`
    box-sizing: border-box;
    box-shadow: 10px 10px 15px 12px #eee;
    border-radius: 1rem;
    padding: 2rem 4rem;
    width: 50%;

    @media only screen and (max-width: ${globalStyles.breakpoints.large}) {
        width: 100%;
        padding: 1rem;
    }
`

export const FormRow = styled.div`
    display: flex;
    margin-bottom: 2rem;

    input:nth-of-type(1) {
        margin-right: 2rem;
    }
`

export const AddressCard = styled.div`
    background-color: #3b82f6;
    color: white;

    box-sizing: border-box;
    border-radius: 1rem;
    padding: 2rem 4rem;
    width: 45%;

    @media only screen and (max-width: ${globalStyles.breakpoints.large}) {
        width: 100%;
        padding: 1rem;
        margin-top: 2rem;
    }
`

export const PrimaryFormButton = styled(MyButton)`

    &:disabled {
        background-color:rgb(114, 150, 226);
        cursor: not-allowed;
    }
`

export const RedStar = styled.span`
    color: red;
`